import { media } from 'styled-bootstrap-grid'
import styled, { css } from 'styled-components'
import { StyledUtils } from '@ocean/utils'
import DelayNavLink from '../DelayNavLink'

type NavigationRootProps = {
  isDesktop: boolean
}

export const NavigationRoot = styled.div<NavigationRootProps>`
  display: flex;
  flex-direction: row;

  ${({ isDesktop }) =>
    isDesktop &&
    `
    flex-direction: column;
  `}
`

const navigationItem = css<NavigationRootProps>`
  display: flex;
  flex-direction: column;
  flex: 1 0;
  height: 60px;
  align-items: center;
  justify-content: center;
  text-align: left;
  text-transform: uppercase;
  transition: color 0.2s ease, background 0.2s ease;

  ${({ theme }) => `
    padding: calc(${theme.space.mobile.tiny} + 2px);
    font-family: ${theme.fontFamily.secondary};
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.fontSize.mobile.tiny};
    color: ${theme.color.white};

    svg path[stroke], svg g[stroke] {
      stroke: ${theme.color.white};
      transition: all 0.2s ease;
    }

    svg g path[fill] {
      fill: ${theme.color.white};
      transition: all 0.2s ease;
    }

    &:hover {
      color: ${theme.color.oceanLight};
      svg path[stroke], svg g[stroke] {
        stroke: ${theme.color.oceanLight};
      }
      svg g path[fill] {
        fill: ${theme.color.oceanLight};
      }
    }

    &.active {
      color: ${theme.color.oceanLight};
      background: ${theme.color.oceanDark};
      svg path[stroke], svg g[stroke] {
        stroke: ${theme.color.oceanLight};
      }
      svg g path[fill] {
        fill: ${theme.color.oceanLight};
      }
    }
  `}

  ${({ theme, isDesktop }) =>
    isDesktop &&
    `
    flex-direction: row;
    flex-shrink: 0;
    border-radius: ${theme.borderRadius.base};
    padding: ${theme.space.mobile.tiny} ${theme.space.desktop.base};
    font-family: ${theme.fontFamily.primary};
    font-size: ${theme.fontSize.desktop.base};
    text-transform: none;
    justify-content: normal;
    height: auto;
  `}
`

export const NavigationLink = styled(DelayNavLink)`
  ${navigationItem}
`

export const NavigationButton = styled.button`
  ${StyledUtils.clearButton}
  ${navigationItem}
`

export const NavigationIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 20px;

  svg {
    width: 22px;
  }
`

type NavigationContentProps = {
  isDesktop: boolean
}

export const NavigationContent = styled.div<NavigationContentProps>`
  flex: 1 0;
  white-space: nowrap;
  display: block;
  font-size: 0.5625rem;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.nano};
  `}

  ${({ theme, isDesktop }) =>
    isDesktop &&
    `
    margin-left: ${theme.space.desktop.tiny};
    margin-top: 0;
    font-size: inherit;
  `}

  ${media.xs`
    display: none;
  `}
`

export const PromoWrapper = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.space.mobile.huge};
  `}
`
